import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { UtilitiesService } from '../../../services/utilities.service';
import { initPopupData } from '../../../model/popup-data';
import { AcquireMerchant } from '../../../services/acquire-onboarding-wizard/acquire-onboarding-wizard.service';
import { MERCHANT_ID_QUERY_PARAM } from '../../../model/client-onboarding/acquire-onboarding-wizard-stepper';
import { Router } from '@angular/router';

export interface MultipleMerchantsDialogData {
  acquirerOnboardingId: number;
  merchants: AcquireMerchant[];
}

@Component({
  selector: 'app-multiple-merchants-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
  ],
  templateUrl: './multiple-merchants-dialog.component.html',
  styleUrl: './multiple-merchants-dialog.component.scss',
})
export class MultipleMerchantsDialogComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  popup = initPopupData;

  acquirerOnboardingId: number | undefined;
  merchantControl = new FormControl<number | null>(null);
  merchants: AcquireMerchant[] = [];
  constructor(
    @Optional()
    private dialogRef: MatDialogRef<MultipleMerchantsDialogComponent> | null,
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    dialogData: MultipleMerchantsDialogData | null,
    private fb: FormBuilder,
    private utilities: UtilitiesService,
    private router: Router,
  ) {
    this.acquirerOnboardingId = dialogData?.acquirerOnboardingId;
    this.merchants = dialogData?.merchants ?? [];
  }

  ngOnInit(): void {
    this.merchantControl = this.fb.control<number | null>(null);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  save(): void {
    const merchantOnboardingId = this.merchantControl.value;
    if (merchantOnboardingId) {
      this.utilities.setMerchantOnboardingId(merchantOnboardingId);
      this.router.navigate(
        [
          'acquire-onboarding',
          this.utilities.clientId,
          this.acquirerOnboardingId,
        ],
        {
          queryParams: { [MERCHANT_ID_QUERY_PARAM]: merchantOnboardingId },
          queryParamsHandling: 'merge',
        },
      );
      this.dialogRef?.close();
    } else {
      this.utilities.showSnackbarAlert({
        ...this.popup,
        title: 'Error',
        content: 'Please select a merchant.',
        warn: true,
        okayBtnText: 'OK',
      });
    }
  }

  cancel(): void {
    this.dialogRef?.close();
  }
}
